import axios from 'axios';
import { useEffect, useRef, useState } from 'react';
import Button from 'react-bootstrap/Button';
// import Form from 'react-bootstrap/Form';
import { GamePlayerContext, LocalPlayerContext, NotificationContext } from '../../context/game-context';
import { Alert, InputGroup, Modal } from 'react-bootstrap';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import { useAuthBasicService } from '../../../blockhain/provider/initiate.provider';

export const AccountRegister = ({ setCurrentStep, setShowTnc }) => {
    const [otp, setOtp] = useState('');
    const [isSubmitting, setSubmitting] = useState(false);
    const registerData = useRef(null);
    const [errorMsg, setErrorMsg] = useState('');
    const [successMsg, setSuccessMsg] = useState('');

    const handleRegister = async (values, actions) => {
        setSubmitting(true);
        // Perform form submission logic here
        // console.log(values, actions);
        setErrorMsg('');
        try {
            const register = await axios.post(`${process.env.API_URL}/auth/register_email`, values, {
                crossDomain: true
            });
            setSuccessMsg("Register Success! Please check email to activate your account");
            registerData.current = register.data;
            // setSubmitting(false);
        } catch (err) {
            console.log(err);
            setSubmitting(false);
            // addToast({ title: "Error", message: err.response.data.message, type: "danger" });

            setErrorMsg(err.response.data.message);

        }
        // // Remember to call setSubmitting(false) when your submission is complete
        setSubmitting(false);
    };
    const isValidEmail = email => {
        // Your email validation logic here
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email);
    };

    const validationSchema = Yup.object().shape({
        nrp: Yup.string().nullable().when('emailDomain', {
            is: (emDom) => { 
                return emDom && emDom != 'public'},
            then: () => Yup.string().required('NRP is required')
        }),
        name: Yup.string().required('Name is required'),
        gender: Yup.string().required('Gender is required'),
        username: Yup.string().required('Username is required'),
        age: Yup.string().required('Age is required'),
        email: Yup.string().required('Email is required'),
        emailDomain: Yup.string().required('Email Domain is required'),
        isAgree: Yup.boolean().oneOf([true], 'You must accept the terms and conditions'),
        // phoneNumber: Yup.string().required('Phone Number is required'),
        password: Yup.string()
            .min(6, 'Password must be at least 6 characters')
            .required('Password is required'),
        confPassword: Yup.string()
            .oneOf([Yup.ref('password'), null], 'Passwords must match')
            .required('Confirm Password is required'),
    });

    const initialValues = {
        name: '',
        gender: '',
        username: '',
        age: '',
        email: '',
        emailDomain: 'public',
        isAgree: false,
        // phoneNumber: '',
        password: '',
        confPassword: '',
    };

    return (
        <>
            <h5 className='my-3 fw-bold'>
                Registrasi
            </h5>
            <hr />
            <div className='row p-0 text-start mb-3'>
                {errorMsg != '' && <Alert variant="danger">{errorMsg}</Alert>}
                {successMsg != '' && <Alert variant="success">{successMsg}</Alert>}
                <Formik
                    initialValues={initialValues}
                    validationSchema={validationSchema}
                    validate={values => {
                        const errors = {};

                        if (values.emailDomain === 'public') {
                            if (!values.email) {
                                errors.email = 'Email is required';
                            } else if (!isValidEmail(values.email)) {
                                errors.email = 'Invalid email format';
                            }
                        }

                        return errors;
                    }}
                    onSubmit={handleRegister}
                >
                    {({ setFieldValue, errors, touched, values }) => (
                        <Form className={`p-0 ${errors && touched && 'needs-validated'}`}>
                            
                            <div className='row mb-3'>
                                <Field type="text" name="nrp" placeholder="NRP" disabled={values.emailDomain === 'public'} className={`form-control ${(touched.nrp && errors.nrp) && 'is-invalid'}`} />

                                {errors.nrp && touched.nrp && (
                                    <div className="invalid-feedback p-0" style={{ display: 'block' }}>{errors.nrp}</div>
                                )}
                            </div>
                            <div className='row mb-3'>
                                <Field type="text" name="name" placeholder="Nama Lengkap" className={`form-control ${(touched.name && errors.name) && 'is-invalid'}`} />

                                {errors.name && touched.name && (
                                    <div className="invalid-feedback p-0" style={{ display: 'block' }}>{errors.name}</div>
                                )}
                            </div>

                            <div className='row mb-3'>
                                <div className='col px-0'>
                                    <Field type="radio" name="gender" value="male" className={`form-check-input mx-2 ${(touched.gender && errors.gender) && 'is-invalid'}`} />
                                    Laki Laki
                                </div>
                                <div className='col px-0'>
                                    <Field type="radio" name="gender" value="female" className={`form-check-input mx-2 ${(touched.gender && errors.gender) && 'is-invalid'}`} />
                                    Perempuan
                                </div>

                                {errors.gender && touched.gender && (
                                    <div className="invalid-feedback p-0" style={{ display: 'block' }}>{errors.gender}</div>
                                )}
                            </div>

                            <div className='row mb-3'>
                                <Field type="number" name="age" placeholder="Umur" className={`form-control ${(touched.age && errors.age) && 'is-invalid'}`} />

                                {errors.age && touched.age && (
                                    <div className="invalid-feedback p-0" style={{ display: 'block' }}>{errors.age}</div>
                                )}
                            </div>

                            <div className='row mb-3'>
                                <Field type="text" name="username" placeholder="Username" className={`form-control ${(touched.username && errors.username) && 'is-invalid'}`} />

                                {errors.username && touched.username && (
                                    <div className="invalid-feedback p-0" style={{ display: 'block' }}>{errors.username}</div>
                                )}
                            </div>

                            <div className='row mb-3'>
                                <InputGroup className='p-0'>
                                    <Field type="text" name="email" placeholder="Email" className={`form-control ${(touched.email && errors.email) && 'is-invalid'}`} />

                                    <Field as="select" name="emailDomain" placeholder="Email" className={`form-select`}>
                                        <option value="public">Public Email</option>
                                        <option value="UT">PT United Tractors Tbk.</option>
                                        <option value="PAMA">PT Pama Persada Nusantara</option>
                                        <option value="KPP">PT Kalimantan Prima Persada</option>
                                        <option value="PTAR">PT Agincourt Resources</option>
                                        <option value="EPN">PT Energia Prima Nusantara</option>
                                        <option value="TTA">PT Tuah Turangga Agung</option>
                                        <option value="ACSET">PT Acset Indonusa Tbk.</option>
                                        <option value="BP">PT Bina Pertiwi</option>
                                        <option value="UTPE">PT United Tractors Pandu Engineering</option>
                                        <option value="PML">PT Patria Maritime Lines</option>
                                        <option value="PMP">PT Patria Maritim Perkasa</option>
                                        <option value="Triatra">PT Triatra</option>
                                        <option value="KRA">PT Komatsu Remanufacturing Asia</option>
                                        <option value="UTSG">PT United Tractors Semen Gresik</option>
                                        <option value="TN">PT Traktor Nusantara</option>
                                    </Field>

                                </InputGroup>
                                {errors.email && touched.email && (
                                    <div className="invalid-feedback p-0" style={{ display: 'block' }}>{errors.email}</div>
                                )}
                                {errors.emailDomain && touched.emailDomain && (
                                    <div className="invalid-feedback p-0" style={{ display: 'block' }}>{errors.emailDomain}</div>
                                )}
                            </div>

                            {/* <div className='row mb-3'>
                                <InputGroup className='p-0'>
                                    <label className='input-group-text m-0'>+62</label>
                                    <Field type="text" name="phoneNumber" placeholder="Nomor Handphone" className={`form-control ${(touched.phoneNumber && errors.phoneNumber) && 'is-invalid'}`} />
                                </InputGroup>

                                {errors.phoneNumber && touched.phoneNumber && (
                                    <div className="invalid-feedback p-0" style={{ display: 'block' }}>{errors.phoneNumber}</div>
                                )}
                            </div>
                             */}

                            <div className='row mb-3'>
                                <Field type="password" name="password" placeholder="Kata Sandi" className={`form-control ${(touched.password && errors.password) && 'is-invalid'}`} />

                                {errors.password && touched.password && (
                                    <div className="invalid-feedback p-0" style={{ display: 'block' }}>{errors.password}</div>
                                )}
                            </div>

                            <div className='row mb-3'>
                                <Field type="password" name="confPassword" placeholder="Konfirmasi Kata Sandi" className={`form-control ${(touched.confPassword && errors.confPassword) && 'is-invalid'}`} />

                                {errors.confPassword && touched.confPassword && (
                                    <div className="invalid-feedback p-0" style={{ display: 'block' }}>{errors.confPassword}</div>
                                )}
                            </div>

                            <div className='form-check mb-3'>
                                <Field type="checkbox" name="isAgree" placeholder="Konfirmasi Kata Sandi" className={`form-check-input ${(touched.isAgree && errors.isAgree) && 'is-invalid'}`} />
                                <label className='form-check-label'>
                                    Saya telah membaca dan menyetujui seluruh <a href="#" onClick={() => setShowTnc(true)}>Syarat dan ketentuan</a> yang berlaku.
                                </label>

                                {errors.isAgree && touched.isAgree && (
                                    <div className="invalid-feedback p-0" style={{ display: 'block' }}>{errors.isAgree}</div>
                                )}
                            </div>

                            <Button variant="primary" type="submit" disabled={isSubmitting} className={"w-100"}>
                                Daftar Registrasi
                            </Button>
                        </Form>
                    )}
                </Formik>
            </div>
            <hr />
            <p className='mb-2'>Sudah punya akun ? login <a className='text-primary' onClick={() => setCurrentStep('login')}>disini</a></p>

        </>
    )
}